// extracted by mini-css-extract-plugin
module.exports = {"formWrapper":"MobileCodeLogin_formWrapper__1L2cp","codeInputWrapper":"MobileCodeLogin_codeInputWrapper__2ECgN","codeSendButton":"MobileCodeLogin_codeSendButton__ggkx1"};